'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_layouts_MainLayout$DrawerNavigateTo$1(active, navigate) {
  this.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_active = null;
  this.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_navigate = null;
  this.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_active = active;
  this.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_navigate = navigate;
}
export { $c_Lapp_layouts_MainLayout$DrawerNavigateTo$1 as $c_Lapp_layouts_MainLayout$DrawerNavigateTo$1 };
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype.constructor = $c_Lapp_layouts_MainLayout$DrawerNavigateTo$1;
/** @constructor */
function $h_Lapp_layouts_MainLayout$DrawerNavigateTo$1() {
}
export { $h_Lapp_layouts_MainLayout$DrawerNavigateTo$1 as $h_Lapp_layouts_MainLayout$DrawerNavigateTo$1 };
$h_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype = $c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype;
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1556605897, true);
});
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_layouts_MainLayout$DrawerNavigateTo$1)) {
    var x = this.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_active;
    var x$2 = x$0.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_active;
    if ((x === x$2)) {
      var x$3 = this.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_navigate;
      var x$4 = x$0.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_navigate;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype.productPrefix__T = (function() {
  return "DrawerNavigateTo";
});
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_active;
  }
  if ((n === 1)) {
    return this.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_navigate;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "active";
  }
  if ((n === 1)) {
    return "navigate";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1.prototype.forAnchor__sci_Seq = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var mods = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([this.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_active]));
  var suffix = this.Lapp_layouts_MainLayout$DrawerNavigateTo$1__f_navigate;
  return mods.appendedAll__sc_IterableOnce__sci_ArraySeq(suffix);
});
function $isArrayOf_Lapp_layouts_MainLayout$DrawerNavigateTo$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_layouts_MainLayout$DrawerNavigateTo$1)));
}
export { $isArrayOf_Lapp_layouts_MainLayout$DrawerNavigateTo$1 as $isArrayOf_Lapp_layouts_MainLayout$DrawerNavigateTo$1 };
var $d_Lapp_layouts_MainLayout$DrawerNavigateTo$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_layouts_MainLayout$DrawerNavigateTo$1, "app.layouts.MainLayout$DrawerNavigateTo$1", ({
  Lapp_layouts_MainLayout$DrawerNavigateTo$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_layouts_MainLayout$DrawerNavigateTo$1 as $d_Lapp_layouts_MainLayout$DrawerNavigateTo$1 };
//# sourceMappingURL=app.layouts.-Main-Layout$-Drawer-Navigate-To$1.js.map
